import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { motion } from "motion/react";
import { ArrowRightIcon, SparklesIcon } from "@heroicons/react/24/outline";

export default function BottomCallToAction() {
  const intl = useIntl();
  return (
    <div className="w-full">
      <motion.div
        className="rounded-2xl bg-gradient-to-br from-slate-50 via-gray-50 to-slate-100 dark:from-gray-800 dark:via-gray-800 dark:to-gray-700 p-6 sm:p-12 lg:p-16 text-center shadow-lg border border-slate-200/60 dark:border-gray-600/60"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <div className="mx-auto max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <span className="inline-flex items-center px-3 py-1.5 rounded-full text-xs font-medium bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 mb-4 sm:mb-6">
              <SparklesIcon className="w-3 h-3 mr-1.5" />
              {intl.formatMessage({
                id: "wpa_prompt_pre_cta",
                defaultMessage: "Hungry for more?",
              })}
            </span>
          </motion.div>

          <motion.h2
            className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 dark:text-gray-100 tracking-tight mb-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <span className="block text-slate-600 dark:text-slate-400">
              {intl.formatMessage({
                id: "wpa_prompt_cta",
                defaultMessage: "Start now for free",
              })}
            </span>
          </motion.h2>

          <motion.p
            className="text-base sm:text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto leading-relaxed mb-6 sm:mb-8"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            Join thousands of successful restaurants already using our platform
            to grow their business.
          </motion.p>

          <motion.div
            className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <motion.div
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
            >
              <Button
                size="xl"
                asChild
                className="shadow-lg transition-all duration-200"
              >
                <Link to="/join">
                  {intl.formatMessage({
                    id: "wpa_get_started",
                    defaultMessage: "Get started",
                  })}
                  <ArrowRightIcon className="ml-2 w-4 h-4" />
                </Link>
              </Button>
            </motion.div>

            <motion.div
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
            >
              <Button
                size="xl"
                variant="outline"
                asChild
                className="bg-white/20 dark:bg-gray-800/20 backdrop-blur-sm border-gray-300/60 dark:border-gray-600/60 hover:bg-white/30 dark:hover:bg-gray-800/30 transition-all duration-200"
              >
                <Link to="/pages/contact">
                  {intl.formatMessage({
                    id: "wpa_link_contact",
                    defaultMessage: "Contact",
                  })}
                </Link>
              </Button>
            </motion.div>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
}
